import { pilot } from '~/services/serviceInstances';
import { PilotId } from '~/types/PilotId';

interface Request {
  sectionId: PilotId;
  fieldOrder: { id: PilotId; position: number }[];
}

export const reorderDataFields = async ({ sectionId, fieldOrder }: Request) => {
  return pilot.put(`client-sections/${sectionId}/field-order/`, fieldOrder);
};
